/** @license ISC License (c) copyright 2019 original and current authors */

/** @author Ian Hofmann-Hicks (evil) */
var Maybe = require('.');

var curry = require('../core/curry');

var isFunction = require('../core/isFunction');

var isSameType = require('../core/isSameType');

var applyTransform = function applyTransform(maybe) {
  return maybe.either(function () {
    return [];
  }, function (x) {
    return [x];
  });
};

var err = 'maybeToArray: Argument must be a Maybe instanstace or a Maybe returning function';

function maybeToArray(maybe) {
  if (isFunction(maybe)) {
    return function (x) {
      var m = maybe(x);

      if (!isSameType(Maybe, m)) {
        throw new TypeError(err);
      }

      return applyTransform(m);
    };
  }

  if (isSameType(Maybe, maybe)) {
    return applyTransform(maybe);
  }

  throw new TypeError(err);
}

module.exports = curry(maybeToArray);